import { useTranslation } from "react-i18next";
import { Label, Input, StringSelect } from "@tellescope/ui";
import type { StripeBillingPortalButtonBlock } from "../../../../../shared/schema";
import { LayoutSection } from "../shared/LayoutSection";
import { VisibilitySection } from "../shared/VisibilitySection";
import type { BlockTypeEditorProps } from "../types";

type StripeBillingPortalButtonBlockEditorProps = BlockTypeEditorProps<StripeBillingPortalButtonBlock>;

export const StripeBillingPortalButtonBlockEditor = ({
  block,
  updateProps,
  updateLayout,
  updateVisibility,
  layoutOpen,
  setLayoutOpen,
  visibilityOpen,
  setVisibilityOpen,
}: StripeBillingPortalButtonBlockEditorProps) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label>{t("Button Label")}</Label>
        <Input
          value={block.props.label}
          onChange={(e) => updateProps({ label: e.target.value || "Manage Subscriptions" })}
          placeholder={t("Manage Subscriptions")}
        />
      </div>
      <StringSelect
        label={t("Button Style")}
        value={block.props.variant}
        onValueChange={(value) => updateProps({ variant: value as StripeBillingPortalButtonBlock["props"]["variant"] })}
        options={[
          { value: "default", label: t("Default") },
          { value: "outline", label: t("Outline") },
          { value: "ghost", label: t("Ghost") },
        ]}
      />
      <LayoutSection layout={block.layout} onChange={updateLayout} open={layoutOpen} onOpenChange={setLayoutOpen} />
      <VisibilitySection
        visibility={block.visibility}
        onChange={updateVisibility}
        open={visibilityOpen}
        onOpenChange={setVisibilityOpen}
      />
    </div>
  );
};
